import type { FC, ReactNode } from 'react'
import type { Course } from '@/types'

import { ArrowRight } from 'lucide-react'
import { ButtonLink } from '@/components/generals/button-link'
import { Container } from '@/components/generals/container'
import { SectionHeading } from '@/components/generals/section-heading'
import { CourseCard } from '@/components/courses/course-card'

interface RelatedCoursesProps {
    courses: Array<Course>
}

export const RelatedCourses: FC<RelatedCoursesProps> = ({ courses }): ReactNode => {
    if (courses.length === 0) return null

    return (
        <section id='related-courses' aria-labelledby='related-courses-title' className='border-t bg-secondary/40 py-16 sm:py-20'>
            <Container>
                <div className='flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between'>
                    <SectionHeading id='related-courses-title' eyebrow="Keep learning" title="You might also like" />

                    <ButtonLink href='/courses' variant='outline' className='self-start sm:self-auto'>
                        All courses
                        <ArrowRight aria-hidden='true' />
                    </ButtonLink>
                </div>

                <div className='mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3'>
                    {courses.map(course => (
                        <CourseCard key={course.id} course={course} />
                    ))}
                </div>
            </Container>
        </section>
    )
}
